import { createSelector } from 'reselect'

import {
  currentSubscriptionSelector,
  isPaymentMethodPaypalSelector
} from 'features/billing/selectors'
import { ownerCountryCodeSelector } from 'selectors/current_organization'

export const billingInformationSelector = createSelector(
  currentSubscriptionSelector,
  ({ billing_information: billingInformation }) => billingInformation
)

export const taxIdSelector = createSelector(
  billingInformationSelector,
  (billingInformation) => billingInformation && billingInformation.tax_id
)

const secondaryTaxIdInfoSelector = createSelector(
  billingInformationSelector,
  (billingInformation) => billingInformation?.secondary_tax_id_info
)

export const secondaryTaxIdSelector = createSelector(
  secondaryTaxIdInfoSelector,
  (secondaryTaxIdInfo) => secondaryTaxIdInfo?.find((t) => t.field_id === 'additionalTaxRegistrationNumber')?.field_value || null
)

export const billingAddressSelector = createSelector(
  billingInformationSelector,
  (billingInformation) => {
    const billingAddress = billingInformation && billingInformation.billing_address

    if (billingAddress && Object.values(billingAddress).some((v) => v)) return billingAddress

    return null
  }
)

export const billingAddressCountrySelector = createSelector(
  billingAddressSelector,
  (billingAddress) => billingAddress?.country
)

export const shippingAddressSelector = createSelector(
  currentSubscriptionSelector,
  ({ shipping_address: shippingAddress }) => shippingAddress
)

export const shippingAddressCountrySelector = createSelector(
  shippingAddressSelector,
  (shippingAddress) => shippingAddress?.country
)

export const availableCountriesSelector = createSelector(
  billingInformationSelector,
  (billingInformation) => billingInformation && billingInformation.available_countries
)

export const availableStatesSelector = createSelector(
  billingInformationSelector,
  (billingInformation) => billingInformation && billingInformation.states_by_country
)

export const isTaxExemptableSelector = createSelector(
  isPaymentMethodPaypalSelector,
  billingAddressSelector,
  ownerCountryCodeSelector,
  (isPaypal, billingAddress, ownerCountryCode) => {
    if (isPaypal) return false

    return billingAddress?.country === 'US' || ownerCountryCode === 'US'
  }
)

export const showTaxIdSectionSelector = createSelector(
  taxIdSelector,
  billingAddressSelector,
  ownerCountryCodeSelector,
  (taxId, billingAddress, ownerCountryCode) => {
    if (taxId) return true

    const { country: billingCountry } = billingAddress || {}

    if (billingCountry) return billingCountry !== 'US'

    return ownerCountryCode !== 'US'
  }
)

export const disabledTaxIdFormSelector = createSelector(
  billingAddressSelector,
  showTaxIdSectionSelector,
  (billingAddress, showTaxId) => {
    const { country: billingCountry } = billingAddress || {}
    const billingCountryPresent = !!billingCountry
    return showTaxId && !billingCountryPresent
  }
)
